import React from "react";
import Placeholder from "../Placeholder/Placeholder";

interface Props {
  description?: string;
  id?: string;
  leftAction?: React.ReactNode;
  title: React.ReactNode;
  children?: React.ReactNode;
  filter?: React.ReactNode;
}

export default function SectionHeader({
  children,
  leftAction,
  description,
  title,
  filter,
}: Props) {
  return (
    <div className={"sectionHeaderContainer"}>
      <div className={"sectionHeaderTitleContainer"}>
        {leftAction ? leftAction : null}
        {title ? <h2 className={"sectionHeaderTitle"}>{title}</h2> : null}
        {description ? <Placeholder title={description} /> : null}
        {filter ? (
          <div className={"flex flex-1 items-end"}>{filter}</div>
        ) : null}
      </div>
      {children ? (
        <div className={"sectionHeaderRightContainer"}>{children}</div>
      ) : null}
    </div>
  );
}
